import { useIntl } from 'react-intl'
import LineCheckCircleIcon from 'LuxKit/Icons/line/LineCheckCircleIcon'
import LineExclamationTriangleIcon from 'LuxKit/Icons/line/LineExclamationTriangleIcon'
import LineTimesCircleIcon from 'LuxKit/Icons/line/LineTimesCircleIcon'
import Tooltip from 'LuxKit/Tooltip'
import BodyTextBlock from 'LuxKit/TextBlocks/BodyTextBlock'

interface Props {
  status?: App.OrderItemStatus
}

export default function LesaPurchaseSummaryOrderItemStatus({ status }: Props) {
  const intl = useIntl()

  const bookingConfirmedMessage = intl.formatMessage({
    id: 'EE1pnrA9NnxdkZbf9IcR',
    defaultMessage: 'Booking confirmed.',
    description: 'Status message indicating a booking has been confirmed',
  })
  const requestPendingMessage = intl.formatMessage({
    id: 'Pc9Llu2UbGZdRXOzoZJ5',
    defaultMessage: 'Request pending...',
    description: 'Status message indicating a booking request is pending',
  })
  const bookingCancelledMessage = intl.formatMessage({
    id: 'Xa2yTdfa4z6dXWy_HI-d',
    defaultMessage: 'Booking cancelled',
    description: 'Status message indicating a booking has been cancelled',
  })
  const datesToBeSelectedMessage = intl.formatMessage({
    id: '7zUOdqUsWiScy4hPe-Fy',
    defaultMessage: 'Dates to be selected',
    description: 'Status message indicating dates still need to be selected for a booking',
  })
  const travellerDetailsNeededMessage = intl.formatMessage({
    id: 'cCEOnDjAWaXZcAECmY4u',
    defaultMessage: 'Traveller details needed',
    description: 'Status message indicating traveller details are required for a booking',
  })

  switch (status) {
    case 'completed':
      return <Tooltip description={bookingConfirmedMessage}><BodyTextBlock variant="small" startIcon={<LineCheckCircleIcon size="XS" colour="success" />}>{bookingConfirmedMessage}</BodyTextBlock></Tooltip>
    case 'pending':
      return <Tooltip description={requestPendingMessage}><BodyTextBlock variant="small" startIcon={<LineExclamationTriangleIcon size="XS" colour="success" />}>{requestPendingMessage}</BodyTextBlock></Tooltip>
    case 'cancelled':
      return <Tooltip description={bookingCancelledMessage}><BodyTextBlock variant="small" startIcon={<LineTimesCircleIcon size="XS" colour="critical" />}>{bookingCancelledMessage}</BodyTextBlock></Tooltip>
    case 'awaiting_dates':
      return <Tooltip description={datesToBeSelectedMessage}><BodyTextBlock variant="small" startIcon={<LineExclamationTriangleIcon size="XS" colour="warning" />}>{datesToBeSelectedMessage}</BodyTextBlock></Tooltip>
    case 'needsDetails':
      return <Tooltip description={travellerDetailsNeededMessage}><BodyTextBlock variant="small" startIcon={<LineExclamationTriangleIcon size="XS" colour="warning" />}>{travellerDetailsNeededMessage}</BodyTextBlock></Tooltip>
    case 'created':
      return <Tooltip description={bookingConfirmedMessage}><BodyTextBlock variant="small" startIcon={<LineCheckCircleIcon size="XS" colour="success" />}>{bookingConfirmedMessage}</BodyTextBlock></Tooltip>
    default:
      return null
  }
}
